import Precio from "./Precio";

export default Precio;